<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <search-item
          ref="searchItem"
          config-module="1110"
          :reset="true"
          :custom-sim-query-placeholder="$t('CargoMsg.Cargo_PlsInput')+($t('SeaExport.FlightNo'))"
          @click-more="value=>{isAdvancedQuery=value}"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <div slot="operations" style="display: flex;">
            <div v-show="!isAdvancedQuery" style="margin-right: 5px;">
              <el-input
                v-model="flightNo"
                :placeholder="$t('CargoMsg.Cargo_PlsInput')+($t('SeaExport.FlightNo'))"
                style="width: 150px;"
              />
            </div>
            <el-button
              type="primary"
              @click="exportToExcel"
            >{{ $t('SeaExport.ExportToExcel') }}</el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper" style="min-height: 350px;">
          <cargo-ag-grid
            config-module="111001"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :check-main-record="false"
            :deselect-main-record="false"
            :auto-fit-content="false"
            style="width: 100%;"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div id="footer-wrapper" class="pagination-wrapper">
          <div class="total-wrapper" style="display: flex;justify-content: flex-end;flex-wrap: wrap;margin-top: 10px;">
            <div style="display: flex;align-content: center;padding-left: 5px;">
              <span style="font-weight: bold;font-size: 13px;">{{ $t('CargoMsg.Cargo_TotalCost') + '：' }}</span>
              <span>{{ totalCost }}</span>
            </div>
            <div style="display: flex;align-content: center;padding-left: 5px;">
              <span style="font-weight: bold;font-size: 13px;">{{ $t('CargoMsg.Cargo_TotalIncome') + '：' }}</span>
              <span>{{ totalRevenue }}</span>
            </div>
            <div style="display: flex;align-content: center;padding-left: 5px;">
              <span style="font-weight: bold;font-size: 13px;">{{ $t('CargoMsg.Cargo_Profit') + '：' }}</span>
              <span>{{ profit }}</span>
            </div>
          </div>
          <cargo-pagination config-module="11100101" :total="total" :page.sync="pageNum" :limit.sync="pageSize" @pagination="toPageQuery" />
        </div>
      </div>
    </div>
  </div></template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import pictureViewWindow from '@/components/Cargo/Job/pictureViewWindow'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { DocumentManage } from '@/utils/commonUtil'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import ColumnUtil from '@/utils/ColumnUtils'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import { queryCharterAndPalletStatistics } from '@/api/booking/flight'
import DateUtils from '@/utils/dateUtils'
import { exportExcel } from '@/utils/tableDataExportUtils'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup'

export default {
  name: 'CharterAndPalletStatistics',
  components: { ChargeCurrencyTotalGroup, searchItem, cargoTemplateSelectorDialog, pictureViewWindow },
  data() {
    return {
      loading: null,
      oldIsAdvanceQuery: false, // 记录上一次操作是否为高级查询
      isAdvancedQuery: false, // 是否为高级查询
      flightNo: '',
      pageNum: 1,
      pageSize: 50,
      total: 0,
      rowData: [],
      selectedNode: null,
      btBillingMAWBEnabled: false,
      btBillingHAWBEnabled: false,
      btPrintMAWBEnabled: false,
      btPrintHAWBEnabled: false,
      templateSelectorDialog: {
        visible: false,
        ctx: null,
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      // 图片展示
      pictureView: {
        visible: false,
        title: '',
        model: {},
        fileName: '',
        job: {},
        type: 'WarehouseIn'
      },
      totalCost: 0,
      totalRevenue: 0
    }
  },
  computed: {
    filter() {
      return this.isAdvancedQuery ? this.complexFilter : this.simpleFilter
    },
    selectedRow() {
      return this.selectedNode ? this.selectedNode.data : null
    },
    profit() {
      return ColumnUtil.formatNumber(this.totalRevenue - this.totalCost, 2)
    }
  },
  created() {
    // 扩展data
    Object.assign(this, {
      simpleFilter: {
        conditions: [],
        branchId: 0
      },
      complexFilter: {
        conditions: [],
        branchId: 0
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        groupDefaultExpanded: 0,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.FlightNo'),
          field: 'flightNo',
          width: 240,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: params => {
              if (params.data.dataType > 1) {
                return params.data.flightNo
              }
              const url = '#/AirExport/AeRouteCentral?flightNo=' + params.data.flightNo
              return `<a href="${url}" style="color: #1E9FFF;">` + params.data.flightNo + '</a>'
            }
          }
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          pinned: 'left',
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OperationDate'),
          field: 'operationDate',
          width: 100,
          cellRenderer: params => {
            return ColumnUtil.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('Pricing.Aircraft'),
          field: 'aircraftType',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_AirlineCompany'),
          field: 'carrierId',
          width: 100,
          cellRenderer: params => {
            return ColumnUtil.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_MblNo'),
          field: 'mbl',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'),
          field: 'customerId',
          width: 100,
          cellRenderer: params => {
            return ColumnUtil.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: 'ETD',
          field: 'etd',
          width: 100,
          cellRenderer: params => {
            return ColumnUtil.dateLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_TotalCost'),
          field: 'totalCost',
          width: 100,
          valueFormatter: params => {
            return params.data.dataType > 2 ? '' : ColumnUtil.formatNumber(params.value, 2)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_TotalIncome'),
          field: 'totalRevenue',
          width: 100,
          valueFormatter: params => {
            return ColumnUtil.formatNumber(params.value, 2)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Profit'),
          field: 'profit',
          width: 100,
          valueFormatter: params => {
            if (!params.data.totalRevenue === 0 || !params.data.totalCost) {
              return 0
            }
            return ColumnUtil.formatNumber(params.data.totalRevenue - params.data.totalCost, 2)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CharterPack'),
          field: 'charterFlightOrCharterVessel',
          width: 100,
          valueFormatter: params => {
            return CommonState.getNameByCode(SystemConstants.CHARTER_FLIGHT_OR_VESSELS, params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_GrossMargin'),
          field: 'sales',
          width: 100,
          valueFormatter: params => {
            if (!params.data.totalRevenue === 0 || !params.data.totalCost) {
              return 0
            }
            return ColumnUtil.formatNumber(params.data.totalRevenue / params.data.totalCost, 2)
          }
        }, {
          headerName: this.$t('CargoMsg.cargo_loading_rate'),
          field: 'loadingRatio',
          width: 100
        }
      ],
      gridApi: null,
      updateBtnStateSeq: 1, // 执行更新按钮状态操作的次序
      documentManage: new DocumentManage()
    })
  },
  beforeMount() {
    const self = this
    this.documentManage.set('showAttachHandler', function(e) {
      self.showAttachHandler(e)
    })
    this.documentManage.set('mblOrHblLink', function(e, docType) {
      self.mblOrHblLink(e, docType)
    })
  },
  mounted() {
    this.$refs.searchItem.keyWords = 'keyWords' // 该输入框用不到，但必须有值，否则简单查询无法验证通过
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 查询[简单查询/高级查询]
    toPageQuery() {
      this.toAdvancedQuery(this.advanceQueryConditions)
    },
    // 简单查询
    toSimpleQuery(keyword) {
      if (!this.flightNo) {
        // 覆盖原查询条件
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('SeaExport.FlightNo'))
        return
      }
      const data = [new AdvancedSearchOption(null, 'flightDesc.FLIGHT_NO', this.flightNo, 'LIKE').formatObj2Json()]
      this.toAdvancedQuery(data)
    },
    // 高级查询
    toAdvancedQuery(data, operator = '') {
      if (data) {
        this.advanceQueryConditions = data
      }
      const start = DateUtils.formatStandardDate(DateUtils.getMonthFirst())
      const date = new Date()
      const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      const end = DateUtils.formatStandardDate(lastDay)
      const filter = {
        branchId: this.$store.getters.currentOfficeId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      if (this.isAdvancedQuery) {
        const hasEtd = this.advanceQueryConditions.findIndex(item => item.fieldName === 'flight.ETD' || item.fieldName === 'job.ETD') > -1
        if (!hasEtd) {
          filter.conditions = [
            new AdvancedSearchOption(null, 'flight.ETD', `type=date,start=${start} 00:00:00,end=${end} 23:59:59`, AdvancedSearchConsts.OPERATOR_RANGE.code).formatObj2Json(),
            new AdvancedSearchOption(null, 'job.ETD', `type=date,start=${start} 00:00:00,end=${end} 23:59:59`, AdvancedSearchConsts.OPERATOR_RANGE.code).formatObj2Json()
          ]
        } else {
          // 添加航班ETD
          const etd = this.advanceQueryConditions.filter(item => item.fieldName === 'job.ETD')
          filter.conditions = [
            new AdvancedSearchOption(null, 'flight.ETD', etd[0].value, etd[0].operator).formatObj2Json()
          ]
        }
      } else {
        filter.conditions = [
          new AdvancedSearchOption(null, 'flight.ETD', `type=date,start=${start} 00:00:00,end=${end} 23:59:59`, AdvancedSearchConsts.OPERATOR_RANGE.code).formatObj2Json(),
          new AdvancedSearchOption(null, 'job.ETD', `type=date,start=${start} 00:00:00,end=${end} 23:59:59`, AdvancedSearchConsts.OPERATOR_RANGE.code).formatObj2Json()
        ]
        filter.conditions.push(...this.advanceQueryConditions)
      }
      if (this.isAdvancedQuery) {
        filter.conditions.push(...this.advanceQueryConditions)
      }
      this.loading = getLoading4Cxt(this)
      queryCharterAndPalletStatistics(filter).then(res => {
        this.rowData = res.data.rows // 保存原始行数据
        if (this.rowData && this.rowData.length > 0) {
          this.rowData.sort((a, b) => b.etd.localeCompare(a.etd) || b.etd.localeCompare(a.etd))
        }
        let totalCost = 0
        let totalRevenue = 0
        if (res.data.rows && res.data.rows.length > 0) {
          for (const row of res.data.rows) {
            if (row.dataType > 1) {
              continue
            }
            totalCost += row.totalCost
            totalRevenue += row.totalRevenue
          }
        }
        this.totalCost = ColumnUtil.roundHalfUp(totalCost, 2)
        this.totalRevenue = ColumnUtil.roundHalfUp(totalRevenue, 2)
        this.total = Number(res.data.total || 0)
        this.gridApi.clearFocusedCell()
      }).finally(() => {
        this.loading.close()
      })
    },
    exportToExcel() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseData'))
        return
      }
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      exportExcel('包机包板统计', rows, [...allDisplayedColumns], false)
    },
    exportExcelAll() {}
  }
}
</script>

<style scoped lang="scss">
#app .app-main-content .grid-view .main-content ::v-deep {
  .cargo-advance-search-quick {
    .el-input {
      display: none;
    }
  }
  .grid-wrapper {
    .ag-theme-balham {
      .ag-row-hover {
        background: #9bddff !important;
      }
    }
  }
}
</style>
